import useAuth from 'src/hooks/useAuth';

const usePlantTerminology = () => {
    const PLANT1_ID = 1; //savigliano
    const PLANT1_IDTEAM = 2; //savigliano
    const PLANT3_ID = 3; //vado
    const PLANT3_IDTEAM = 10; //vado
    const PLANT3_IDUO_STAIRS = 106; //mettere codice scale vado 106 
    const PLANT3_IDUO_SLINGSROPESCHAINS  = 107; //mettere codice brache-funi-catene vado 107

    const { user } = useAuth();
    
    const isPlant3 = user?.idplant === PLANT3_ID;

    const getIdTeamForPlant = () => isPlant3 ? PLANT3_IDTEAM : PLANT1_IDTEAM;

    const getIdUOStairsPlant3 = () => isPlant3 ? PLANT3_IDUO_STAIRS : null;
    const getIdUOSlingsRopesChainsPlant3 = () => isPlant3 ? PLANT3_IDUO_SLINGSROPESCHAINS : null;
    
    const getPlantLabel = (type) => {
        const labels = {
            detail: {
                default: 'pm.Dettaglio ciclo',
                plant3: 'pm.Dettaglio scheda'
            },
            cyclecreatecod: {
                default: 'Codice Ciclo',
                plant3: 'Codice Scheda'
            },
            cyclecreatedes: {
                default: 'Descrizione Ciclo',
                plant3: 'Descrizione Scheda'
            },
            cyclecreatedef: {
                default: 'Definizione Ciclo',
                plant3: 'Definizione Scheda'
            },
            cyclecreatedef2: {
                default: 'Definizione Cicli',
                plant3: 'Definizione Schede'
            },
            cyclecreatenew: {
                default: 'Nuovo Ciclo',
                plant3: 'Nuova Scheda'
            },
            entity: {
                default: 'pm.Ciclo',
                plant3: 'pm.Scheda'
            },
            navbar: {
                default: 'Definizione Cicli',
                plant3: 'Definizione Schede'
            },
            orderseditview: {
                default: 'pm.Rendicontazione ciclo',
                plant3: 'pm.Rendicontazione scheda'
            },
            smpcyclelistviewadd: {
                default: 'pm.Aggiungi a ciclo',
                plant3: 'pm.Aggiungi a a scheda'
            },
        };

        const item = labels[type];

        if (!item) {
            return '';
        }

        return isPlant3
            ? item.plant3
            : item.default;
    };

    return {
        getPlantLabel,
        getIdTeamForPlant,
        getIdUOStairsPlant3,
        getIdUOSlingsRopesChainsPlant3,
        isPlant3
    };
};

export default usePlantTerminology;